__webpack_require__.p = "/Choice-Predicting-App/";